import {BORDER_WIDTH} from '../../../spotlight/libs';

export const Circle = ({active = false, scale = 1}) => {
  return (
    <svg
      className="absolute size-full"
      style={{filter: 'drop-shadow(0 2px 5px rgba(0, 0, 0, 0.1))'}}
    >
      <circle
        cx="50%"
        cy="50%"
        r={`min(calc(${50 / scale}%), calc(50% - 4px))`}
        fill="rgba(228, 56, 151, 0.1)"
        stroke="#e43897"
        strokeWidth={BORDER_WIDTH / scale}
        strokeDasharray={active ? '8 8' : undefined}
      />
      <g
        id="circle-cursor"
        width="28"
        height="28"
        viewBox="0 0 28 28"
        style={{transformOrigin: 'center'}}
        transform={`translate(${14 / scale} ${14 / scale}) scale(${1 / scale})`}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.2458 20.11L20.991 23.558C21.1487 23.87 21.0241 24.2506 20.7121 24.4083L18.831 25.3603C18.519 25.518 18.1384 25.3935 17.9807 25.0815L16.2355 21.6335L13.2275 23.5158L13.2344 13.0758C13.2344 12.5546 13.8298 12.2575 14.247 12.5706L22.5418 18.8015L19.2458 20.11Z"
          fill="white"
          stroke="#E43897"
          strokeWidth="1.6504"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.99958 12.8571H3.71387"
          stroke="#E43897"
          strokeWidth="1.6504"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.2857 12.8571H22"
          stroke="#E43897"
          strokeWidth="1.6504"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.34385 18.5144L6.73242 20.1258"
          stroke="#E43897"
          strokeWidth="1.6504"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.2677 5.58862L19.6562 7.20005"
          stroke="#E43897"
          strokeWidth="1.6504"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.0001 2.57153V4.85725"
          stroke="#E43897"
          strokeWidth="1.6504"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.73242 5.58862L8.34385 7.20005"
          stroke="#E43897"
          strokeWidth="1.6504"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
